/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber11Small = createReactComponent("outline", "number-11-small", "IconNumber11Small", [["path", { "d": "M8 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M14 10l2 -2v8", "key": "svg-1" }]]);

export { IconNumber11Small as default };
//# sourceMappingURL=IconNumber11Small.mjs.map
